<template>
  <!-- BEGIN: Header -->
  <header
    id="m_header"
    class="m-grid__item    m-header"
    m-minimize-offset="200"
    m-minimize-mobile-offset="200"
  >
    <div class="preloader" style="display:none;">
      <h3>Please wait while Data loads</h3>
      <div class="gooey">
        <span class="dot"></span>
        <div class="dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
  </div>
    <div class="m-container m-container--fluid m-container--full-height">
      <div class="m-stack m-stack--ver m-stack--desktop">
        <!-- BEGIN: Brand -->
        <div class="m-stack__item m-brand m-brand--skin-dark">
          <div class="m-stack m-stack--ver m-stack--general">
            <div class="m-stack__item m-stack__item--middle m-brand__logo">
              <a href="#/dashboard" class="m-brand__logo-wrapper">
                <img alt="" :src="logo_url + '/logo.png'" />
              </a>
            </div>
            <div class="m-stack__item m-stack__item--middle m-brand__tools">
              <!-- BEGIN: Left Aside Minimize Toggle -->
              <a
                href="javascript:;"
                id="m_aside_left_minimize_toggle"
                @click="toggleAsideMenu"
                class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-desktop-inline-block"
              >
                <span></span>
              </a>
              <!-- END -->
              <!-- BEGIN: Responsive Aside Left Menu Toggler -->
              <a
                href="javascript:;"
                id="m_aside_left_offcanvas_toggle"
                @click="toggleAsideMobileMenu"
                class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-tablet-and-mobile-inline-block"
              >
                <span></span>
              </a>
              <!-- END -->
              <!-- BEGIN: Responsive Header Menu Toggler -->
              <a
                id="m_aside_header_menu_mobile_toggle"
                @click="toggleHeaderbarMobileMenu"
                href="javascript:;"
                class="m-brand__icon m-brand__toggler m--visible-tablet-and-mobile-inline-block"
              >
                <span></span>
              </a>
              <!-- END -->
              <!-- BEGIN: Topbar Toggler -->
              <a
                id="m_aside_header_topbar_mobile_toggle"
                @click="toggleTopbarMobileMenu"
                href="javascript:;"
                class="m-brand__icon m--visible-tablet-and-mobile-inline-block"
              >
              <div class="mobile-img" @click="showmobilemenu()" @blur="removesubmenu()">
                  <img  width="30" height="30" :src="profileImageURL" @error="setAltImg"  alt="" />
              </div>
              </a>
              <!-- BEGIN: Topbar Toggler -->
            </div>
          </div>
        </div>
        <!-- END: Brand -->
        <div
          class="m-stack__item m-stack__item--fluid m-header-head"
          id="m_header_nav"
        >
          <!-- BEGIN: Horizontal Menu -->
          <button
            @click="toggleHeaderbarMobileMenu"
            class="m-aside-header-menu-mobile-close  m-aside-header-menu-mobile-close--skin-dark "
            id="m_aside_header_menu_mobile_close_btn"
          >
            <i class="flaticon-close"></i>
          </button>
          <div
            id="m_header_menu"
            class="m-header-menu m-aside-header-menu-mobile m-aside-header-menu-mobile--offcanvas  m-header-menu--skin-light m-header-menu--submenu-skin-light m-aside-header-menu-mobile--skin-dark m-aside-header-menu-mobile--submenu-skin-dark"
          >
            <div class="img-logo">
              <img :src="logo_url + '/logo.png'" />
            </div>
            <ul class="m-menu__nav  m-menu__nav--submenu-arrow">
              <li
                class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                m-menu-submenu-toggle="click"
                m-menu-link-redirect="1"
                aria-haspopup="true"
              >
                <router-link
                  to="/classroom"
                  class="m-menu__link m-menu__toggle"
                >
                  <span class="m-menu__link-title">
                    <span class="m-menu__link-wrap">
                      <span class="m-menu__link-text">Classrooms</span>
                      <span class="m-menu__link-badge">
                        <span class="m-badge m-badge--brand m-badge--wide" style="top:0px">
                          Live
                        </span>
                      </span>
                    </span>
                  </span>
                </router-link>
              </li>
            </ul>
          </div>
          <!-- END: Horizontal Menu -->
          <!-- BEGIN: Topbar -->
          <div
            id="m_header_topbar"
            class="m-topbar  m-stack m-stack--ver m-stack--general"
          >
            <div class="m-stack__item m-topbar__nav-wrapper">
              <ul class="m-topbar__nav m-nav m-nav--inline">
                <li id="mobiletopbar"
                  class="m-nav__item m-topbar__user-profile m-topbar__user-profile--img  m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light"
                  m-dropdown-toggle="click"
                >
                  <a href="#" class="m-nav__link m-dropdown__toggle">
                    <span class="m-topbar__userpic">
                      <img
                        :src="profileImageURL" @error="setAltImg"
                        class="m--img-rounded m--marginless m--img-centered"
                        alt=""
                      />
                    </span>
                    <span class="m-topbar__username m--hide">{{
                      firstName
                    }}</span>
                  </a>
                  <div class="m-dropdown__wrapper">
                    <span
                      class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"
                    ></span>
                    <div class="m-dropdown__inner" id="mobile-sub-menu">
                      <div class="close-panel" @click="hidesubmenu()">
                        <img src="images/close.png" />
                      </div>
                      <div class="m-dropdown__header m--align-center">
                        <div class="m-card-user m-card-user--skin-dark">
                          <div class="m-card-user__pic">
                            <img
                              src=""
                              class="m--img-rounded m--marginless"
                              alt=""
                            />
                          </div>
                          <div class="m-card-user__details">
                            <span class="m-card-user__name m--font-weight-500"
                              >{{ firstName }} {{ lastName }}</span
                            >
                            <a v-if="email != 'null'"
                              href=""
                              class="m-card-user__email m--font-weight-300 m-link"
                              >{{ email }}</a
                            >
                            <p v-if="student_no != 'null'" class="stno">
                              <b>Student No : {{ student_no }}</b>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="m-dropdown__body">
                        <div class="m-dropdown__content">
                          <ul class="m-nav m-nav--skin-light">
                            <li class="m-nav__section m--hide">
                              <span class="m-nav__section-text">Section</span>
                            </li>
                            <li class="m-nav__item" v-if="userPermissions.profile_edit">
                              <router-link
                                to=""
                                class="m-nav__link"
                                data-toggle="modal"
                                data-target="#profile-modal"
                                @click.native="getStudentDetail"
                              >
                                <i
                                  class="m-nav__link-icon flaticon-profile-1"
                                ></i>
                                <span class="m-nav__link-title">
                                  <span class="m-nav__link-wrap">
                                    <span class="m-nav__link-text"
                                      >My Profile</span
                                    >
                                  </span>
                                </span>
                              </router-link>
                            </li>
                            <!-- <li class="m-nav__item">
                              <a href="#" class="m-nav__link">
                                <i class="m-nav__link-icon flaticon-book"></i>
                                <span class="m-nav__link-text">FAQs</span>
                              </a>
                            </li> -->
                            <li class="m-nav__item">
                              <a
                                href="https://support.webcolms.com/415-2/"
                                target="_blank"
                                class="m-nav__link"
                              >
                                <i
                                  class="m-nav__link-icon flaticon-support"
                                ></i>
                                <span class="m-nav__link-text">Help</span>
                              </a>
                            </li>
                            <li
                              class="m-nav__separator m-nav__separator--fit"
                            ></li>
                            <li class="m-nav__item">
                              <button
                                v-if="isMultiClient"
                                class="btn btn-warning btn-info text-white switch-btn"
                                data-toggle="modal"
                                data-target="#school-login-modal"
                              >
                                Switch Institutes
                              </button>
                              <a href="#" @click="logout()" class="btn m-btn--pill btn-secondary m-btn m-btn--custom m-btn--label-brand m-btn--bolder btn-info log-btn">
                                Logout
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="info">
              <h3>{{ firstName }} {{ lastName }}</h3>
              <p v-if="student_no != 'null'">Student No: {{ student_no }}</p>
          </div>
          <div class="inst-name">{{ company.company_name }}</div>
          <!-- END: Topbar -->
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade modern"
      id="profile-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <form>
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Profile Information
              </h5>
              <img
                class="close"
                src="/media/icons/close.png"
                data-dismiss="modal"
                aria-label="Close"
                width="53px"
              />
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger"
                    id="profile_error"
                    style="display: none;"
                  ></div>
                  <div
                    class="alert alert-success"
                    id="profile_success"
                    style="display: none;"
                  ></div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="profile-area">
                    <label class="text-center">Update Profile Picture</label>
                    <div class="circle">
                      <label for="pro-upload">
                        <img src="media/icons/cam.png" />
                      </label>
                      <input
                        class="pro-upload"
                        type="file"
                        id="pro-upload"
                        name="file"
                        ref="file"
                        v-on:change="handleFileUpload()"
                      />
                      <img class="circle-img" :src="editImageURL" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="first_name">First Name</label>
                    <input
                      type="text"
                      v-model="studentDetails.first_name"
                      id="first_name"
                      name="first_name"
                      class="form-control"
                      placeholder="First Name"
                    />
                    <span
                      id="first_name_error"
                      style="display:none"
                      class="text-danger"
                      >This field is required</span
                    >
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="last_name">Last Name</label>
                    <input
                      type="text"
                      id="last_name"
                      name="last_name"
                      v-model="studentDetails.last_name"
                      class="form-control"
                      placeholder="Last Name"
                    />
                    <span
                      id="last_name_error"
                      style="display:none"
                      class="text-danger"
                      >This field is required</span
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="phone">Phone</label>
                    <input
                      type="tel"
                      pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                      v-model="studentDetails.phone"
                      class="form-control"
                      name="phone"
                      id="phone"
                      placeholder="Phone Number"
                    />
                    <span
                      id="phone_error"
                      style="display:none"
                      class="text-danger"
                      >This field is required</span
                    >
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="dob">Date of Birth</label>
                    <datetime
                      format="yyyy-MM-dd"
                      v-model="studentDetails.dob"
                      placeholder="YYYY-MM-DD"
                      input-class="form-control"
                      name="dob"
                    >
                    </datetime>
                    <span
                      id="dob_error"
                      style="display:none"
                      class="text-danger"
                      >This field is required</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button class="btn btn-danger btn-info" @click="updateStudent">
              Update
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MultiClient Modal -->
    <div
      class="modal modern fade"
      id="school-login-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Switch Institutes
            </h5>
            <img
              class="close"
              src="/media/icons/close.png"
              data-dismiss="modal"
              aria-label="Close"
              width="53px"
            />
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="middle-login">
                  <div
                    class="alert alert-danger notify-bar mb-5"
                    role="alert"
                    id="fail-login"
                    style="display:none"
                  ></div>
                  <a
                    v-for="(client, index) in clientList"
                    :key="index"
                    href="#"
                    @click="switchInstitutes(client)"
                    class="school-login"
                  >
                    <div class="logo-inner">
                      <img src="media/icons/school.png" />
                    </div>
                    <div class="school-name">{{ client.company_name }}</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <!-- END: Header -->
</template>

<script>
import { isMobile } from 'mobile-device-detect'
import Vue from 'vue'
import axios from 'axios'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
var $ = require('jquery')
Vue.component('datetime', Datetime)
var Config = require('../../router/Config')
var Cookies = require('vue-cookies')

Vue.mixin({
  methods: {
    numberWithCommas: function (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    setAltImg(event) {
      event.target.src = "images/default.png"
    }
  }
})
export default {
  name: 'header',
  components: {},
  data () {
    return {
      studentDetails: [],
      logo_url: Config.LOGO_URL(),
      api_url: Config.API_URL,
      firstName: '',
      lastName: '',
      student_no: '',
      email: '',
      sidebarMenu: false,
      headerbarMenu: false,
      topbarMenu: false,
      profileImageURL: './media/users/blank-profile-picture.png',
      editImageURL: './media/users/blank-profile-picture.png',
      isMultiClient: false,
      clientList: [],
      isMobile: isMobile,
      sessionInterval: null,
      company : '',
      userPermissions: [],
    }
  },
  mounted () {
    $('#fail-login').hide()
    this.userPermissions = Cookies.get("userPermissions");
    this.firstName = Cookies.get('firstName')
    this.lastName = Cookies.get('lastName')
    this.email = Cookies.get('email')
    this.user = Cookies.get('userDetail')
    this.student_no = Cookies.get('student_number')
    this.company = Cookies.get('company')
    this.getStudentDetail()
    var profileImage = Cookies.get('profileImage')
    if (profileImage !== 'null') {
      this.profileImageURL = this.api_url + '/user/' + profileImage
      this.editImageURL = this.api_url + '/user/' + profileImage
    }
    this.refreshSessionForUser()
  },
  methods: {
    logout () {
      var appos = Cookies.get('appos')
      axios.post(Config.API_URL + '/api/fe/auth/removeSession?token=' + Cookies.get('accessToken'), {
        deviceSessionId: Cookies.get('deviceSessionId')
      }).then(response => {
        var allCookies = Cookies.keys()
        allCookies.forEach(items => {
          Cookies.remove(items)
        })
        clearInterval(this.sessionInterval)
        this.$emit('authenticated', false)
        if (this.isMobile) {
          this.logoutFromMobileApp(appos, '')
        }
        location.reload()
      }).catch(function (error) {
        console.log(error)
      })

    },
    logoutFromMobileApp (appos, message) {
      try {
        if (appos === 'ios') {
          if (window.webkit) {
            window.webkit.messageHandlers.logout.postMessage(message)
          }
        } else if (appos === 'android') {
          Android.logout(message)
        }
      } catch (error) {
        console.log(error)
      }
    },
    showmobilemenu () {
      // $('body').toggleClass('m-brand--minimize')
      // $('body').toggleClass('m-aside-left--minimize')
      $("#mobile-sub-menu").toggleClass('m-dropdown--open')
      $('#mobiletopbar').toggleClass('m-dropdown--open')
      $('body').toggleClass('mobilemenushow')
    },
    removesubmenu() {
      $("#mobile-sub-menu").removeClass('m-dropdown--open')
      $('#mobiletopbar').removeClass('m-dropdown--open')
      $('body').addClass('mobilemenushow')
    },
    hidesubmenu() {
      $("#mobile-sub-menu").removeClass('m-dropdown--open')
      $('#mobiletopbar').removeClass('m-dropdown--open')
    },
    toggleAsideMenu () {
      $('body').toggleClass('m-brand--minimize')
      $('body').toggleClass('m-aside-left--minimize')
    },
    toggleAsideMobileMenu () {
      if (this.sidebarMenu) {
        this.sidebarMenu = false
      } else {
        this.sidebarMenu = true
        if (this.headerbarMenu) {
          this.toggleHeaderbarMobileMenu()
        }
        if (this.topbarMenu) {
          this.toggleTopbarMobileMenu()
        }
      }
      $('#m_aside_left_offcanvas_toggle').toggleClass(
        'm-brand__toggler--active'
      )
      $('#m_aside_left').toggleClass('m-aside-left--on')
      $('body').toggleClass('m-aside-left--on')
    },
    toggleHeaderbarMobileMenu () {
      if (this.headerbarMenu) {
        this.headerbarMenu = false
      } else {
        this.headerbarMenu = true
        if (this.sidebarMenu) {
          this.toggleAsideMobileMenu()
        }
        if (this.topbarMenu) {
          this.toggleTopbarMobileMenu()
        }
      }
      $('body').toggleClass('m-aside-header-menu-mobile--on')
      $('#m_header_menu').toggleClass('m-aside-header-menu-mobile--on')
    },
    toggleTopbarMobileMenu () {
      if (this.topbarMenu) {
        this.topbarMenu = false
      } else {
        this.topbarMenu = true
        if (this.sidebarMenu) {
          this.toggleAsideMobileMenu()
        }
        if (this.headerbarMenu) {
          this.toggleHeaderbarMobileMenu()
        }
      }
      $('body').toggleClass('m-topbar--on')
    },
    getStudentDetail: function () {
      $('#first_name_error').hide()
      $('#last_name_error').hide()
      $('#dob_error').hide()
      $('#phone_error').hide()
      $('#file_error').hide()
      axios
        .post(
          Config.API_URL +
            '/api/fe/student/profile-detail?token=' +
            Cookies.get('accessToken'),
          {
            id: Cookies.get('studentId'),
            dateFormat: true
          }
        )
        .then(response => {
          this.studentDetails = response.data.data
          this.student_no = this.studentDetails.student_number
          Cookies.set('currency', response.data.currency)
          if (response.data.isMultiClient) {
            this.isMultiClient = true
            this.clientList = response.data.clientList
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    updateStudent: function () {
      $('#first_name_error').hide()
      $('#last_name_error').hide()
      $('#dob_error').hide()
      $('#phone_error').hide()
      $('#file_error').hide()
      if (this.studentDetails.first_name === '') {
        $('#first_name_error').show()
        return false
      }
      if (this.studentDetails.last_name === '') {
        $('#last_name_error').show()
        return false
      }
      if (this.studentDetails.dob === '') {
        $('#dob_error').show()
        return false
      }
      if (this.studentDetails.phone === '') {
        $('#phone_error').show()
        return false
      }
      // if (this.file.type !== 'image/jpeg' || this.file.type !== 'image/png') {
      //   $('#file_error').show()
      //   return false
      // }

      const formData = new FormData()
      formData.append('first_name', this.studentDetails.first_name)
      formData.append('last_name', this.studentDetails.last_name)
      formData.append('dob', this.studentDetails.dob)
      formData.append('phone', this.studentDetails.phone)
      formData.append('id', this.studentDetails.id)
      formData.append('file', this.file)
      this.axios
        .post(
          Config.API_URL +
            '/api/fe/student/profile-update' +
            '?token=' +
            Cookies.get('accessToken'),
          formData
        )
        .then(response => {
          if (response.data.res === '1') {
            Cookies.set('profileImage', response.data.user.image)
            Cookies.set('firstName', response.data.data.first_name)
            Cookies.set('lastName', response.data.data.last_name)
            this.firstName = response.data.data.first_name
            this.lastName = response.data.data.last_name
            this.profileImageURL =
              this.api_url + '/user/' + response.data.user.image
            $('#profile_success').html(response.data.msg)
            $('#profile_success')
              .fadeTo(5000, 500)
              .slideUp(500, function () {
                $('#profile_success').slideUp(500)
              })
          } else {
            $('#profile_error').html(response.data.msg)
            $('#profile_error')
              .fadeTo(5000, 500)
              .slideUp(500, function () {
                $('#profile_error').slideUp(500)
              })
          }
        })
    },
    switchInstitutes: function (studentClientData) {
      if (studentClientData.student_active_flag === 0) {
        $('#fail-login').text(
          'Your student account for this Institute has been disabled, please contact administrator'
        )
        $('#fail-login').show()
      } else if (studentClientData.client_status === 0) {
        $('#fail-login').text(
          'Sorry, Your Institute has been inactivated by the system. Please contact Institute Administration for details.'
        )
        $('#fail-login').show()
      } else {
        Cookies.remove('clientId')
        Cookies.remove('firstName')
        Cookies.remove('lastName')
        Cookies.remove('userPermissions')
        Cookies.remove('usertype')
        Cookies.remove('userDetail')
        Cookies.remove('studentId')
        Cookies.remove('currency')
        Cookies.remove('student_number')
        Cookies.remove('company')
        Cookies.set('clientId', studentClientData.client_id)
        Cookies.set('firstName', studentClientData.first_name)
        Cookies.set('lastName', studentClientData.last_name)
        Cookies.set('userPermissions', studentClientData.userPermissions)
        Cookies.set('usertype', studentClientData.user_type_id)
        Cookies.set('userDetail', studentClientData.user_data)
        Cookies.set('studentId', studentClientData.student_id)
        Cookies.set('currency', studentClientData.currency)
        Cookies.set('company', studentClientData.companyData)
        Cookies.set('student_number', studentClientData.student_number)
        location.reload()
      }
    },
    numberWithCommas: function (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    handleFileUpload: function () {
      this.file = this.$refs.file.files[0]
      if (
        this.$refs.file.files[0].type === 'image/png' ||
        this.$refs.file.files[0].type === 'image/jpeg'
      ) {
        this.editImageURL = URL.createObjectURL(this.file)
      } else {
        $('#profile_error').html('Please upload an image file (PNG/JPEG).')
        $('#profile_error')
          .fadeTo(5000, 500)
          .slideUp(500, function () {
            $('#profile_error').slideUp(500)
          })
      }
    },
    refreshSessionForUser: function () {
      var self = this
      this.sessionInterval = setInterval(function() {
        self.axios.post(Config.API_URL + '/api/fe/auth/refreshSessionForUser', {
          user_id: Cookies.get('userId'),
          client_id: Cookies.get('clientId'),
          deviceSessionId:  Cookies.get('deviceSessionId')
        }).then(response => {
          var result = response.data
          console.log('refreshSessionForUser')
          console.log(result)
        }).catch(function (error) {
          console.log(error)
        })
      }, 600000)  //runs every 10 mins

    }
  },
  events: {
    closeEvent: function () {
      console.log('close event called')
      $('body').removeClass('mobilemenushow')
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/scss/component/header/header';
</style>
